import React, { Component, createRef } from 'react';
import Highcharts from 'highcharts';
import drilldown from 'highcharts-drilldown';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";
import { getDDMMYYYY } from '../common/utils';

drilldown(Highcharts);

export default class ColumnDrilldownLoadingDashboard extends Component {

  constructor(props) {
    super(props);
    this.chartRef = createRef();
    this.wrapperRef = createRef();
    this.state = {
      selectedTransporter: null,
      transportData: [],
      loading: false,
      chartWidth: Math.max(props.series.length * 40, 1350)
    };
  }

  setWidth = (width) => {
    if (this.wrapperRef.current) {
      this.wrapperRef.current.style.width = width + 'px';
    }
    if (this.chartRef.current && this.chartRef.current.chart) {
      this.chartRef.current.chart.setSize(width, null, false);
    }
    this.setState({ chartWidth: width });
  };

  updateChartWidth = (count = 0) => {
    const width = Math.max(count * 40, 1300);
    this.setWidth(width);
  };

  handleTransporterClick = async (point) => {
    const transporter = point.name;

    this.setState({
      selectedTransporter: transporter,
      loading: true,
      transportData: []
    });

    try {
      const rqparams = {
        dept_code: this.props.dept_code
      };

      const res = await redirectURL.post(
        "/consignments/summarysecondleveldata",
        rqparams
      );

      let criticaldata = res.data.message[0].critical_data;

      let filtered = [];

      if (this.props.dept_code === 'LOG-SC') {
        filtered = criticaldata.filter(
          item => item.transporters_name === transporter
        );
      } else {
        filtered = criticaldata.filter(
          item => item.transporter_name === transporter
        );
      }

      filtered.sort((a, b) => b.transit_delay_days - a.transit_delay_days);

      this.setState({
        transportData: filtered,
        loading: false
      });

    } catch (e) {
      console.log("Error:", e);
      this.setState({ loading: false });
    }
  };

  render() {
    const self = this;

    const highchartoptions = {
      chart: {
        type: 'column',
        animation: false,
        spacingTop: 30, // extra space at top so breadcrumb and hamburger don't collide
        events: {
          drilldown: function () {
            const chart = this;
            setTimeout(() => {
              const count = chart.series[0] ? chart.series[0].data.length : 0;
              const width = Math.max(count * 40, 1300);
              self.setWidth(width);
            }, 50);
          },
          drillup: function () {
            const originalWidth = Math.max((self.props?.series?.length || 0) * 40, 1300);
            if (self.wrapperRef.current) {
              self.wrapperRef.current.style.width = originalWidth + 'px';
            }
            this.setSize(originalWidth, null, false);
            this.xAxis[0].update({ type: 'category' }, false);
            self.setState({ chartWidth: originalWidth });
          }
        }
      },

      title: {
        text: ""
      },

      xAxis: {
        type: 'category'
      },

      yAxis: {
        title: {
          text: this.props.yaxistitle
        }
      },

      legend: {
        enabled: false
      },

      // Keep the hamburger export menu, push it down slightly
      navigation: {
        buttonOptions: {
          y: -35
        }
      },

      plotOptions: {
        series: {
          animation: false,
          cursor: 'pointer',
          point: {
            events: {
              click: (e) => {
                this.handleTransporterClick(e.point);
              }
            }
          }
        }
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>' +
          '<span>No of trips:</span> <b>{point.weights}</b>'
      },

      series: [{
        name: "Transporters",
        colorByPoint: true,
        data: this.props.series
      }],

      drilldown: {
        animation: false,
        // Push the "Back to transporters" breadcrumb below the hamburger menu
        breadcrumbs: {
          position: {
            align: 'left',
            y: 30
          }
        },
        series: this.props.drilldownseries
      },

      credits: false
    };

    return (
      <div>
        {this.props.title && (
          <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold'}}>
            {this.props.title}
          </div>
        )}

        <div style={{ overflowX: 'auto' }}>
          <div ref={this.wrapperRef} style={{ width: this.state.chartWidth }}>
            <HighchartsReact
              ref={this.chartRef}
              highcharts={Highcharts}
              options={highchartoptions}
              allowChartUpdate={false}
            />
          </div>
        </div>
      </div>
    );
  }
}